import React from "react"
import { firestore } from "../core"
import { usePublicItems } from "popopo-lib-front/firestore-access"
import { Spinner } from "react-bootstrap"
import { NavLink } from "react-router-dom"
import { Paths } from "../paths"

export const Items = () => {
  const items = usePublicItems(firestore)

  if (items === "loading") {
    return <Spinner/>
  }

  return (<>
    <div className="row mt-5 gy-5 justify-content-center">
      <h2>アイテム</h2>
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {items.map(item => (
          <div className="col" key={item.id}>
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  <NavLink to={Paths.items.item.getPath(item.id)}>
                    {item.id}: {item.name}
                  </NavLink>
                </h5>
                <p className="card-text">{item.description}</p>
              </div>
              <div className="card-footer">
                <small className="text-muted">Last updated {new Date(item.updated_at).toLocaleString()}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

  </>)
}
